import verifySignatureGeneric from "./verifySignatureGeneric";

// A ---------------------------------------------------------------------- M

export const verifySignature = (userId, record, type) => verifySignatureGeneric(userId, record, type, "txid");
export const verifySignatureAIC = (userId, record, type) => verifySignatureGeneric(userId, record, type, "AIC_txid");
